import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequestSmpAsDatafan } from "../../_helpers";
export const ApiDatafanSmpProviders = {
    list: (query) => apiRequestSmpAsDatafan({
        endpoint: `${REACT_APP__URL_SMP_API}/oauth-client/v1/providers`,
        method: "GET",
        query,
    }),
};
//# sourceMappingURL=providers.js.map